import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ComponentsModule } from '../../components/components.module';
import { EventsPage } from './events';

// import { AngularFirestore } from 'angularfire2/firestore';

@NgModule({
  declarations: [
    EventsPage,
  ],
  imports: [
    ComponentsModule,
    IonicPageModule.forChild(EventsPage),
  ]
})
export class EventsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/events/events.module.ts